import { ChangeDetectorRef, inject, Pipe, PipeTransform } from '@angular/core'
import { SourceService } from 'src/app/service/source.service'
import { AsyncPipe } from '@angular/common'
import { map } from 'rxjs'

@Pipe({ name: 'userToken', standalone: true })
export class UserTokenPipe implements PipeTransform {
  protected userToken$ = inject(SourceService).getUserToken$()
  protected asyncPipe: AsyncPipe

  constructor (cdr: ChangeDetectorRef) {
    this.asyncPipe = new AsyncPipe(cdr)
  }

  transform (url: string): string {
    return this.asyncPipe.transform(this.userToken$.pipe(map(token => {
      const urlObject = new URL(url)
      if (token) {
        urlObject.searchParams.set('e_token', this.userToken$.value)
      }
      return urlObject.toString()
    }))) as string
  }
}
